import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/corporate-accounts/{id}/patrons/stats'

interface UseGetPatronStatsParams {
  corporateAccountId?: number
  startDate: Date
  endDate: Date
  licensedEstablishmentId: number
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd HH:mm:ss')

export const useGetPatronStats = ({
  corporateAccountId,
  startDate,
  endDate,
  licensedEstablishmentId,
}: UseGetPatronStatsParams) =>
  useApiQuery({
    path,
    method: 'get',
    queryKey: [
      path,
      corporateAccountId,
      formatDate(startDate),
      formatDate(endDate),
      licensedEstablishmentId,
    ],
    queryArgs: {
      id: corporateAccountId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      singleLeId: licensedEstablishmentId,
    },
  })
